<mat-drawer-container class="one-container" autosize>
    <mat-drawer #drawer class="one-sidenav" mode="side" [opened]="opened">
        <mat-list>
            <mat-list-item class="nav">
                <mat-icon aria-hidden="false" 
                            aria-label="Home icon"
                            routerLink="/requests"
                            routerLinkActive="active">home</mat-icon>
            </mat-list-item>

            <mat-list-item class="nav" [ngClass]="{'hidden': !isAdmin}">
                <mat-icon [ngClass]="{'c-active': isInGroup == true}"
                            aria-hidden="false" 
                            aria-label="Group icon"
                            routerLink="/groups"
                            routerLinkActive="active">folder_open</mat-icon>
            </mat-list-item>

            <mat-list-item class="nav" [ngClass]="{'hidden': !isAdmin}">
                <mat-icon aria-hidden="false" 
                            aria-label="Report icon"
                            routerLink="/report"
                            routerLinkActive="active">bar_chart</mat-icon>
            </mat-list-item>

            <mat-list-item class="nav">
                <mat-icon aria-hidden="false" 
                            aria-label="Search icon"
                            routerLink="/search"
                            routerLinkActive="active">search</mat-icon>
            </mat-list-item>
          </mat-list>        
    </mat-drawer>
    <mat-drawer-content>
        <router-outlet></router-outlet>
    </mat-drawer-content>
</mat-drawer-container>